module.exports = "/images/vendor/desiigner-svg/svg/places/family.svg?fb75d9ca76377fc5278d2dc6496b6454";